import image from "./../../assets/images/other/image-empty.jpg";

export const addDefaultImageSrc = (
  e: React.SyntheticEvent<HTMLImageElement, Event>
) => {
  e.currentTarget.src = image;
};
